// import { Button, Col, Row } from "react-bootstrap";
// import { NoData } from "../common/NoData";
// import { updateGigInsuranceData } from "../../features/product";
// import Accordion from "react-bootstrap/Accordion";
// import { useDispatch } from "react-redux";
// // import { currencySymbols } from '../../config/currencySymbols';
// import "../customCheckbox.css";
// import { CompanyDetails } from "../CompanyDetails";
// import { useState } from "react";
// import { currencySymbols } from "../../config/constants";
// import { useTranslation } from "react-i18next";

// export const GigCompanyCard = ({ data, buyNowHandler }) => {
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language;
//   const dispatch = useDispatch();
//   const [show, setShow] = useState(false);

//   const handleShow = () => setShow(true);

//   return (
//     <div className="policy-formBox details-box">
//       <div className="header-container">
//         <div className="header-details">
//           <div className="logo-text">
//             <div className={data?.company_image ? "policy-logo" : "w-100"}>
//               {data?.company_image ? (
//                 <img
//                   src={data?.company_image ?? ""}
//                   alt={data?.company_name}
//                   className="img-fluid"
//                 ></img>
//               ) : (
//                 <h4>{data?.company_name} </h4>
//               )}
//             </div>
//             <div className="logo-text-content">
//               <h4>{data?.company_name}</h4>
//               <Button className="btn h-btn">
//                 {t("planName")} - {data?.plan_name}
//               </Button>
//             </div>
//           </div>

//           <div>
//             <div className="sidebar-btn">
//               <Button className="btn h-btn">
//                 {t("basePrice")} : {data?.base_price} {data?.premium_currency}
//               </Button>
//               <Button className="btn h-btn" onClick={handleShow}>
//                 {t("view_more")}
//               </Button>
//             </div>
//             <CompanyDetails
//               show={show}
//               companyData={data}
//               handleClose={() => setShow(false)}
//             />
//           </div>
//         </div>
//         <h5 className="graphic-text">
//           {data?.product_id === 15 && data?.sub_product_id === 20
//             ? `${t("graphical_area_label")} : ${
//                 currentLanguage === "ar"
//                   ? data?.area_of_coverage?.display_value_ar || "NA"
//                   : data?.area_of_coverage?.display_value_en || "NA"
//               }`
//             : `${t("vehicle-value")} : ${
//                 data?.extracted_data?.valuations ||
//                 data?.extracted_data?.vehicle_valuation ||
//                 "NA"
//               }`}
//         </h5>
//       </div>

//       <div className="main-details">
//         <Row>
//           <Col md={12} sm={12}>
//             <div className="details-item mt-3">
//               <h5 className="title">{t("optionalcovers")}</h5>
//               <ul className="horizontal-list">
//                 {data?.optional_covers && data?.optional_covers.length ? (
//                   data.optional_covers.map((cover_item, coverIndex) => (
//                   cover_item.name == 'Cost of First Aid and/or Rescue' ? <></>  :  <li
//                       key={`cover_master_${coverIndex}`}
//                       className={cover_item?.isSelected ? "active" : ""}
//                     >
//                       <label
//                         htmlFor={`${data?.plan_name}_cover_cb_${coverIndex}`}
//                         className="d-flex align-items-center cursor-pointer"
//                       >
//                         <input
//                           id={`${data?.plan_name}_cover_cb_${coverIndex}`}
//                           type="checkbox"
//                           className="custom-checkbox me-2"
//                           checked={cover_item?.isSelected}
//                           onChange={() =>
//                             dispatch(
//                               updateGigInsuranceData({
//                                 object_id: data?.object_id,
//                                 value: cover_item?.coverPremium?.amount,
//                                 customAction: cover_item?.isSelected
//                                   ? "decrement"
//                                   : "increment",
//                                 cover_id: cover_item?.id,
//                               })
//                             )
//                           }
//                         />
//                         {cover_item?.name} - {cover_item?.coverPremium?.amount}{" "}
//                         {cover_item?.coverPremium?.currencyCode}
//                       </label>
//                     </li>
//                   ))
//                 ) : (
//                   <li>
//                     <NoData msg={t("noCoverMsg")} />
//                   </li>
//                 )}
//               </ul>
//             </div>
//           </Col>
//           <Col md={12} sm={12}>
//             <Accordion className="my-5 custom-accordion">
//               <Accordion.Item eventKey="0" className="mt-0 details-item">
//                 <Accordion.Header className="title">
//                   <b>{t("includedcovers")}</b>
//                 </Accordion.Header>
//                 <Accordion.Body>
//                   <ul className="horizontal-list">
//                     {data?.included_covers?.length ? (
//                       data.included_covers.map((cover_item, coverIndex) => (
//                         <li key={`cover_master_${coverIndex}`}>
//                           {cover_item?.name}
//                           {cover_item?.sumInsured
//                             ? `${cover_item?.sumInsured?.amount == "0" ? '' : ` - ${cover_item?.sumInsured?.amount} ${
//                                 currencySymbols[
//                                   cover_item?.sumInsured?.currencyCode
//                                 ]
//                               }`}`
//                             : ""}
//                         </li>
//                       ))
//                     ) : (
//                       <li>
//                         <NoData msg={t("noCoverMsg")} />
//                       </li>
//                     )}
//                   </ul>
//                 </Accordion.Body>
//               </Accordion.Item>
//             </Accordion>
//           </Col>
//         </Row>
//       </div>
//       {data?.product_id === 15 && data?.sub_product_id === 20 ? (
//         <div className="form-note">
//           <h4>{t("formNote.disclaimer")}</h4>
//           <p>{t("formNote.note")}</p>
//         </div>
//       ) : (
//         ""
//       )}
//       <div className="details-footer">
//         <div className="detailsfooter-item">
//           <h4 className="title">
//             <span className="totalPayment">{t("totalPayment")}:</span>{" "}
//             <span className="total-price">{data?.premium_value}</span>{" "}
//             <span className="totalPayment-currency">
//               {data?.premium_currency} (<span>{t("vat_include")}</span>)
//             </span>
//           </h4>
//           <Button className="btn h-btn" onClick={() => buyNowHandler(data)}>
//             {t("buyNow")}
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };


import { Button, Col, Row } from "react-bootstrap";
import { NoData } from "../common/NoData";
import { updateGigInsuranceData } from "../../features/product";
import { useDispatch } from "react-redux";
import "../customCheckbox.css";
import { CompanyDetails } from "../CompanyDetails";
import { useState } from "react";
import { currencySymbols } from "../../config/constants";
import { useTranslation } from "react-i18next";
import "../../components/InsuranceCard.css";
import { ReactComponent as OmrSymbol } from "../../assets/SVG/omr_symbol.svg";

export const GigCompanyCard = ({ data, buyNowHandler }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showAllCovers, setShowAllCovers] = useState(false);
  const handleShow = () => setShow(true);
  const [isCovers, setShowCover] = useState(false);

  const isTravel = data?.product_id === 15 && data?.sub_product_id === 20;

  return (
    <div className="card insurance-card h-100 shadow-sm">
      {/* Header Section */}
      <div className="card-header-custom">
        <a className="details-link" onClick={() => {
              handleShow()  
              setShowCover(false)

            }}>
              ⓘ {t("view_details")}
            </a>
        <div className="flex-fill">
          <div className="insurance-row just">
            <div className="insurance-logo mt-6">
              <img
                src={data?.company_image}
                alt={data?.company_name}
              />
            </div>
            <div className="insurance-content mt-2">
              <h4 className="company-title">{t(data.company_name.toLowerCase()
                    .trim()
                    .replace(/\s+/g, "_")        // replace spaces with _
                    .replace(/[^\w_]/g, ""))}</h4>

              <div className="badge-row gap-2">

                <div className="badge-column">
                  <span className="badge-grey">{t('instantInsurance')}</span>
                  <span className="badge-grey">{t('branches')}: 2</span>

                </div>

                <div className="badge-column">
                  <span className="badge-grey">{t('endorsement24to48')}</span>
                  {/* {!isTravel && (
                    <span className="badge-dark-yellow">{t('photosNotRequired')}</span>
                  )} */}
                  <span className="badge-dark-yellow">  {t("planName")} - {data?.plan_name}</span>

                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Area/Vehicle Value */}
        {/* {data?.product_id === 15 && data?.sub_product_id === 20 ? (
          <div className="badge-light-custom w-100 text-center">
            {t("graphical_area_label")}: {currentLanguage === "ar"
              ? data?.area_of_coverage?.display_value_ar || "NA"
              : data?.area_of_coverage?.display_value_en || "NA"}
          </div>
        ) : (
          <div className="badge-light-custom w-100 text-center">
            {t("vehicle-value")}: {data?.extracted_data?.valuations ||
              data?.extracted_data?.vehicle_valuation ||
              "NA"}
          </div>
        )} */}
      </div>

      <CompanyDetails
        show={show}
        companyData={data}
        isCovers={isCovers}
        handleClose={() => setShow(false)}
      />

      {/* Included Covers Section */}
      {/* <div className="card-body">
        <h6 className="section-title">{t("includedcovers")}</h6>
        <Row className="g-2">
          {data?.included_covers?.length ? (
            data.included_covers.map((cover_item, coverIndex) => (
              <Col xs={6} key={`cover_included_${coverIndex}`}>
                <div className="cover-item">
                  <span className="checkmark-icon">✓</span>
                  <span>
                    {cover_item?.name}
                    {cover_item?.sumInsured && cover_item?.sumInsured?.amount !== "0"
                      ? ` - ${cover_item?.sumInsured?.amount} ${currencySymbols[cover_item?.sumInsured?.currencyCode]
                      }`
                      : ""}
                  </span>
                </div>
              </Col>
            ))
          ) : (
            <Col xs={12}>
              <NoData msg={t("noCoverMsg")} />
            </Col>
          )}
        </Row>
      </div> */}

    <div className="p-3 h-[100px]">
        <h6 className="section-title">{t("includedcovers")}</h6>
        <Row className="g-1">
          {data?.included_covers && data?.included_covers.length ? (
            <>
              {(showAllCovers ? data.included_covers : data.included_covers.slice(0, 4)).map((cover_item, coverIndex) => (
                <Col xs={6} key={`cover_included_${coverIndex}`}>
                  <div className="cover-item">
                    <span className="checkmark-icon">✓</span>
                    <span>
                      {cover_item?.name}
                      {cover_item?.sumInsured && cover_item?.sumInsured?.amount !== '0'
                        ? ` - ${cover_item?.sumInsured?.amount} ${currencySymbols[cover_item?.sumInsured?.currencyCode]}`
                        : ""}
                    </span>
                  </div>
                </Col>
              ))}
              {data.included_covers.length > 4 && (
                <div className="p-0 m-0">
                  <button
                    className="btn btn-link p-0 m-0 text-decoration-none"
                    style={{ color: '#ff9800', fontSize: '0.9rem' }}
                    // onClick={() => setShowAllCovers(!showAllCovers)}
                    onClick={() => {
                       setShow(true)
                      setShowCover(true)}
                    }

                  >
                    {showAllCovers ? "See less" : t('see_more')}
                  </button>
                </div>
              )}
            </>
          ) : (
            <Col xs={12}>
              <NoData msg={t("noCoverMsg")} />
            </Col>
          )}
        </Row>
      </div>

      {/* Optional Covers Section */}
      <div className="card-body pt-0">
        {data?.optional_covers && data?.optional_covers.length ? (<h6 className="section-title">{t("optionalcovers")}</h6>) : <div></div>}

        <Row className="g-1 align-items-stretch">
          {data?.optional_covers && data?.optional_covers.length ? (
            data.optional_covers.map((cover_item, coverIndex) =>
              cover_item.name === 'Cost of First Aid and/or Rescue' ? null : (
                <Col xs={6} key={`cover_optional_${coverIndex}`}>
                  <div className="optional-item">
                    <input
                      id={`${data?.plan_name}_cover_cb_${coverIndex}`}
                      type="checkbox"
                      className="checkbox-custom"
                      checked={cover_item?.isSelected}
                      onChange={() =>
                        dispatch(
                          updateGigInsuranceData({
                            object_id: data?.object_id,
                            value: cover_item?.coverPremium?.amount,
                            customAction: cover_item?.isSelected
                              ? "decrement"
                              : "increment",
                            cover_id: cover_item?.id,
                          })
                        )
                      }
                    />
                    <label
                      htmlFor={`${data?.plan_name}_cover_cb_${coverIndex}`}
                      style={{ cursor: 'pointer', margin: 0 }}
                    >
                      {cover_item?.name} - {cover_item?.coverPremium?.amount}{" "}
                      {cover_item?.coverPremium?.currencyCode}
                    </label>
                  </div>
                </Col>
              )
            )
          ) : (
            <Col xs={12}>
            </Col>
          )
          }
        </Row>
      </div>

       
      {/* Pricing Footer */}
      <div className="pricing-section mt-auto">
        <div className="price-row">

          {/* LEFT : Base Price */}
          <div className="base-price-section">
              <h5 className="graphic-text">
              {data?.product_id === 15 && data?.sub_product_id === 20
                ? `${t("graphical_area_label")} : ${currentLanguage === "ar"
                  ? data?.area_of_coverage?.display_value_ar || "NA"
                  : data?.area_of_coverage?.display_value_en || "NA"
                }`
                : `${t("vehicle-value")} : ${data?.extracted_data?.vehicle_valuation || "N/A"
                }`}
            </h5>
            <div className="base-price-label">{t("basePrice")}</div>

            <div className="base-price-inline">
              <span className="currency-icon" style={{ marginTop: "4px" }}>
                {data?.premium_currency === "OMR" ? (
                  <OmrSymbol width={24} height={24} />
                ) : (
                  data?.premium_currency
                )}
              </span>
              <div>
                <span className="base-price-value">  {parseFloat(data?.base_price || 0).toFixed(3)}</span>
                <span className="tax-inline">+VAT Inc</span>
              </div>
            </div>
          </div>

          {/* RIGHT : Total + Button */}
          <div className="total-price-section">
            <div className="total-price-label">{t("totalPayment")}</div>

            <div className="total-price-value">
              <span className="currency-icon">
                {data?.premium_currency === "OMR" ? (
                  <OmrSymbol width={24} height={24} />
                ) : (
                  data?.premium_currency
                )}
              </span>
              {parseFloat(data?.premium_value || 0).toFixed(3)}
            </div>

            <button
              className="btn-buy-now"
              onClick={() => buyNowHandler(data)}
            >
              {t("buyNow")}
            </button>
          </div>

        </div>

        {/* <div className="vat-note">
          ({t("vat_include")})
        </div> */}
      </div>

    </div>
  );
};
